import $ from 'jquery';
import { ManagePage } from '../Manage/_ManagePage.js';

export default class TextResize {
  constructor() {}

  setTextScale() {
    const target = $('.slideTxt__ul[data-slide-id=' + ManagePage.getCurrentPageNum() + ']');

    target.find('.slideTxt--tate').each(function (index, el) {
      const h = $(el).find('img').height();
      $(el).height(h);
    });

    target.find('.slideTxt--yoko').each(function (index, el) {
      const w = $(el).find('img').width();
      $(el).width(w);
    });

  }

  // テキスト：原宿サン・アド
  // setTxtHHScale() {
  //   const target = $('.txtHH');
  //   const h = target.height();
  //   target.css('margin-top', -h);
  // }
}
